export default __webpack_public_path__ + "static/media/airlytics.e4e0adf9.png";